module.exports = __webpack_public_path__ + "img/item.b8845245.png";